import { BasicLayout } from '@/layout'

const memberRouter = {
  path: '/member',
  name: 'Member',
  alwaysShow: true,
  component: BasicLayout,
  redirect: '/member/index',
  meta: { title: '用户管理', icon: 'peoples' },
  children: [
    {
      path: 'index',
      name: 'MemberIndex',
      meta: { title: '用户列表' },
      component: () => import('@/views/member/index')
    },
    {
      path: 'store',
      name: 'MemberStore',
      meta: { title: '合作商管理' },
      component: () => import('@/views/member/store')
    },
    {
      path: 'branch',
      name: 'MemberBranch',
      meta: { title: '联盟企业管理' },
      component: () => import('@/views/member/branch')
    },
    {
      path: 'franchisee',
      name: 'MemberFranchisee',
      meta: { title: '加盟企业管理' },
      component: () => import('@/views/member/franchisee')
    }
  ]
}

export default memberRouter
